export enum MessageTemplateTypes {
    EMAIL = "email",
    SMS = "sms",
}